import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("edupilot_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(() => !!localStorage.getItem("edupilot_token") && !localStorage.getItem("edupilot_user"));

  useEffect(() => {
    const token = localStorage.getItem("edupilot_token");
    if (token && !user) {
      setLoading(true);
      api.get("/auth/me")
        .then((r) => {
          setUser(r.data);
          localStorage.setItem("edupilot_user", JSON.stringify(r.data));
        })
        .catch(() => {})
        .finally(() => setLoading(false));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const login = async (email, password, otp_code = null) => {
    setLoading(true);
    try {
      const body = { email, password };
      if (otp_code) body.otp_code = otp_code;
      const { data } = await api.post("/auth/login", body);
      localStorage.setItem("edupilot_token", data.token);
      if (data.refresh_token) localStorage.setItem("edupilot_refresh", data.refresh_token);
      localStorage.setItem("edupilot_user", JSON.stringify(data.user));
      setUser(data.user);
      // Force password change gate
      if (data.user?.must_change_password) {
        try { window.location.href = "/profil?force-pw=1"; } catch { /* noop */ }
      }
      return data.user;
    } finally { setLoading(false); }
  };

  const register = async (payload) => {
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", payload);
      localStorage.setItem("edupilot_token", data.token);
      localStorage.setItem("edupilot_user", JSON.stringify(data.user));
      setUser(data.user);
      return data.user;
    } finally { setLoading(false); }
  };

  const logout = async () => {
    const refresh_token = localStorage.getItem("edupilot_refresh");
    try { await api.post("/auth/logout", { refresh_token }); } catch { /* noop */ }
    localStorage.removeItem("edupilot_token");
    localStorage.removeItem("edupilot_refresh");
    localStorage.removeItem("edupilot_user");
    setUser(null);
    window.location.href = "/giris";
  };

  const refresh = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
    localStorage.setItem("edupilot_user", JSON.stringify(data));
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
